// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Component-specific styles */

/* Button styles */
.btn {
	padding: 0.75rem 1.5rem;
	border: none;
	border-radius: var(--radius-md);
	font-size: 1rem;
	font-weight: 500;
	cursor: pointer;
	transition: var(--transition-fast);
	display: inline-flex;
	align-items: center;
	justify-content: center;
	gap: var(--spacing-sm);
	text-decoration: none;
	min-height: 44px; /* Accessibility: minimum touch target */
}

.btn:focus {
	outline: none;
	box-shadow: var(--shadow-focus);
}

.btn:disabled {
	opacity: 0.5;
	cursor: not-allowed;
	transform: none !important;
}

.btn-primary {
	background: var(--primary-gradient);
	color: white;
}

.btn-primary:hover:not(:disabled) {
	transform: translateY(-2px);
	box-shadow: 0 4px 20px rgba(102, 126, 234, 0.4);
}

.btn-secondary {
	background: #e2e8f0;
	color: var(--text-secondary);
}

.btn-secondary:hover:not(:disabled) {
	background: #cbd5e0;
}

.btn-success {
	background: var(--success-color);
	color: white;
}

.btn-success:hover:not(:disabled) {
	background: var(--success-hover);
	transform: translateY(-1px);
}

.btn-warning {
	background: var(--warning-color);
	color: var(--text-secondary);
}

.btn-warning:hover:not(:disabled) {
	background: #ecc94b;
	transform: translateY(-1px);
}

.btn-danger {
	background: var(--danger-color);
	color: white;
}

.btn-danger:hover:not(:disabled) {
	background: #c53030;
	transform: translateY(-1px);
}

.btn-info {
	background: #17a2b8;
	color: white;
}

.btn-info:hover:not(:disabled) {
	background: #138496;
}

.btn-large {
	padding: var(--spacing-lg) var(--spacing-xxl);
	font-size: 1.25rem;
	border-radius: var(--radius-lg);
}

.btn-small {
	padding: var(--spacing-sm) var(--spacing-md);
	font-size: 0.875rem;
}

.btn-transparent {
	background: transparent;
	border: none;
}

/* Layout grids */
.grid-2 {
	display: grid;
	grid-template-columns: 1fr 1fr;
	gap: var(--spacing-xl);
	margin-top: var(--spacing-xl);
}

/* Home screen action buttons grid */
/* .home .action-buttons {
	display: grid;
	grid-template-areas: 
		"btn-reg btn-tkt btn-tickets"
		"status activity activity";
	grid-template-columns: 1fr 1fr 1fr;
	grid-template-rows: auto auto;
	gap: var(--spacing-lg);
	margin: var(--spacing-lg) 0;
} */

.grid-3 {
	display: grid;
	grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
	gap: var(--spacing-lg);
	margin: var(--spacing-xl) 0;
}

.user-info {
	display: flex;
	justify-content: space-between;
	align-items: center;
	gap: 20px;
	margin-bottom: var(--spacing-md);
}

.user-info-text {
	display: flex;
	flex-direction: column;
}

@media (max-width: 768px) {
	.grid-2 {
		grid-template-columns: 1fr;
		gap: var(--spacing-md);
		margin: var(--spacing-md) 0;
	}

	.grid-3 {
		grid-template-columns: 1fr;
		gap: var(--spacing-md);
		margin: var(--spacing-md) 0;
	}

	/* Responsive home screen action buttons */
	/* .home .action-buttons {
		grid-template-areas: 
			"btn-reg"
			"btn-tkt"
			"btn-tickets"
			"status"
			"activity";
		grid-template-columns: 1fr;
		grid-template-rows: auto auto auto auto auto;
	} */
}

/* Card styles */
.card {
	background: var(--bg-card);
	border-radius: var(--radius-lg);
	padding: var(--spacing-lg);
	border: 1px solid rgba(255, 255, 255, 0.3);
	box-shadow: var(--shadow-md);
	transition: var(--transition-fast);
}

/* .card:hover {
	transform: translateY(-2px);
	box-shadow: var(--shadow-lg);
} */

/* Form styles */
.form-group {
	margin-bottom: var(--spacing-lg);
}

.form-label {
	display: block;
	font-weight: 600;
	margin-bottom: var(--spacing-sm);
	color: var(--text-secondary);
}

.form-input,
.form-select {
	width: 100%;
	padding: 0.75rem;
	border: 2px solid var(--border-light);
	border-radius: var(--radius-md);
	font-size: 1rem;
	transition: var(--transition-fast);
	background: white;
	min-height: 44px; /* Accessibility */
}

.form-input:focus,
.form-select:focus {
	outline: none;
	border-color: var(--border-focus);
	box-shadow: var(--shadow-focus);
}

.form-input:invalid {
	border-color: var(--danger-color);
}

/* Camera feed styles */
.camera-feed {
	background: #000;
	border-radius: var(--radius-md);
	aspect-ratio: 16/9;
	display: flex;
	align-items: center;
	justify-content: center;
	color: white;
	font-size: 1.25rem;
	margin-bottom: var(--spacing-md);
	position: relative;
	overflow: hidden;
}

.camera-feed img {
	width: 100%;
	height: 100%;
	object-fit: cover;
}

.camera-overlay {
	position: absolute;
	bottom: 10px;
	left: 10px;
	background: var(--bg-overlay);
	color: white;
	padding: var(--spacing-sm);
	border-radius: 0 var(--radius-lg) 0 0;
	font-size: 0.875rem;
	width: fit-content;
}

/* Weight display styles */
.weight-display {
	background: #2d3748;
	color: #68d391;
	font-family: 'Courier New', monospace;
	font-size: 2rem;
	font-weight: bold;
	padding: var(--spacing-md);
	border-radius: var(--radius-md);
	text-align: center;
	margin: var(--spacing-md) 0;
	min-height: 4rem;
	display: flex;
	align-items: center;
	justify-content: center;
	animation: pulse 2s infinite;
}

@keyframes pulse {
	0% { box-shadow: 0 0 0 0 rgba(104, 211, 145, 0.7); }
	70% { box-shadow: 0 0 0 10px rgba(104, 211, 145, 0); }
	100% { box-shadow: 0 0 0 0 rgba(104, 211, 145, 0); }
}

/* Status indicator styles */
.status-indicator {
	display: flex;
	align-items: center;
	gap: var(--spacing-sm);
	padding: var(--spacing-xs) 0.75rem;
	border-radius: var(--radius-pill);
	font-size: 0.875rem;
	font-weight: 500;
	transition: var(--transition-fast);
}

.status-connected {
	background: #d4edda;
	color: #155724;
}

.status-disconnected {
	background: #f8d7da;
	color: #721c24;
}

.status-dot {
	width: 8px;
	height: 8px;
	border-radius: 50%;
	/* animation: blink 1.5s infinite; */
}

.connected .status-dot {
	background: #28a745;
}

.disconnected .status-dot {
	background: var(--danger-color);
}

@keyframes blink {
	0%, 50% { opacity: 1; }
	51%, 100% { opacity: 0.3; }
}

/* Wizard styles */
.wizard-steps {
	display: flex;
	justify-content: space-evenly;
	margin-bottom: var(--spacing-xl);
	padding: 0 var(--spacing-xl);
	overflow-x: auto;
	gap: var(--spacing-md);
	overflow: visible;
	border-bottom: 1px solid var(--border-light);
	border-top: 1px solid var(--border-light);
	padding: var(--spacing-md) 0;
}

.wizard-step {
	display: flex;
	align-items: center;
	gap: var(--spacing-sm);
	color: var(--text-light);
	font-weight: 500;
	white-space: nowrap;
	transition: var(--transition-fast);
}

.wizard-step.active {
	color: var(--primary-color);
}

.wizard-step.completed {
	color: var(--success-color);
	cursor: pointer;
}

.wizard-step.completed:hover {
	background-color: #f0f0f0;
	transform: scale(1.02);
	transition: all 0.2s ease;
}

.step-number {
	width: 32px;
	height: 32px;
	border-radius: 50%;
	background: var(--border-light);
	color: var(--text-secondary);
	display: flex;
	align-items: center;
	justify-content: center;
	font-weight: bold;
	font-size: 0.875rem;
	transition: var(--transition-fast);
}

.wizard-step.active .step-number {
	background: var(--primary-color);
	color: white;
	transform: scale(1.1);
}

.wizard-step.completed .step-number {
	background: var(--success-color);
	color: white;
}

.wizard-actions {
	display: flex;
	justify-content: space-between;
	margin-top: var(--spacing-xl);
	padding-top: var(--spacing-xl);
	border-top: 1px solid var(--border-light);
	gap: var(--spacing-md);
}

/* Product and selection grids */
.product-grid {
	display: grid;
	grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
	gap: var(--spacing-md);
	/* max-height: 400px; */
	max-height: calc(100vh - 670px);
	overflow-y: auto;
	padding: var(--spacing-md);
	border: 1px solid var(--border-light);
	border-radius: var(--radius-md);
}

.product-grid.projects {
	max-height: calc(100vh - 520px);
}

.product-item {
	padding: var(--spacing-md);
	border: 2px solid var(--border-light);
	border-radius: var(--radius-md);
	cursor: pointer;
	transition: var(--transition-fast);
	text-align: center;
	background: white;
}

.product-item:hover {
	border-color: var(--primary-color);
	background: #f7fafc;
	transform: translateY(-2px);
}

.product-item.selected {
	border-color: var(--primary-color);
	background: #ebf4ff;
}

/* Search and filters */
.search-box {
	margin-bottom: var(--spacing-md);
}

.recently-used {
	margin-bottom: var(--spacing-xl);
}

.recently-used h3 {
	margin-bottom: var(--spacing-md);
	color: var(--text-secondary);
}

/* Authentication screen */
.auth-screen {
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	text-align: center;
	gap: var(--spacing-xl);
	min-height: 60vh;
}

.auth-icon {
	font-size: 4rem;
	color: var(--primary-color);
	animation: bounce 2s infinite;
}

@keyframes bounce {
	0%, 20%, 53%, 80%, 100% { transform: translateY(0); }
	40%, 43% { transform: translateY(-10px); }
	70% { transform: translateY(-5px); }
	90% { transform: translateY(-2px); }
}

/* Summary table */
.summary-table {
	background: var(--bg-secondary);
	border-radius: var(--radius-md);
	overflow: hidden;
	margin: var(--spacing-md) 0;
}

.summary-row {
	display: flex;
	justify-content: space-between;
	padding: var(--spacing-md);
	border-bottom: 1px solid var(--border-light);
	align-items: center;
}

.summary-row:last-child {
	border-bottom: none;
	font-weight: bold;
	background: #f7fafc;
}

/* Navigation breadcrumb */
.nav-breadcrumb {
	display: flex;
	align-items: center;
	gap: var(--spacing-sm);
	margin-bottom: var(--spacing-md);
	font-size: 0.875rem;
	color: var(--text-muted);
}

.nav-breadcrumb a {
	color: var(--primary-color);
	text-decoration: none;
	cursor: pointer;
	transition: var(--transition-fast);
}

.nav-breadcrumb a:hover {
	text-decoration: underline;
	color: var(--primary-hover);
}

/* Loading spinner */
.loading-spinner {
	width: 40px;
	height: 40px;
	border: 4px solid var(--border-light);
	border-top: 4px solid var(--primary-color);
	border-radius: 50%;
	animation: spin 1s linear infinite;
	margin: 0 auto;
}

.date-selector {
	display: flex;
	align-items: center;
	gap: 10px;
	font-family: sans-serif;
  }
  
  .date-label {
	font-weight: 500;
	color: #333;
  }
  
  .date-input {
	width: 160px;
	padding: 6px 10px;
	border: 1px solid #ccc;
	border-radius: 6px;
	font-size: 14px;
	color: #333;
	background-color: #fff;
	outline: none;
	transition: border-color 0.2s, box-shadow 0.2s;
  }
  
  .date-input:focus {
	border-color: #4a90e2;
	box-shadow: 0 0 0 2px rgba(74, 144, 226, 0.2);
  }
  

@keyframes spin {
	0% { transform: rotate(0deg); }
	100% { transform: rotate(360deg); }
}

/* Alert and notification styles */
.alert {
	padding: var(--spacing-md);
	border-radius: var(--radius-md);
	margin: var(--spacing-md) 0;
	border: 1px solid;
}

.alert-warning {
	background: #fef5e7;
	border-color: var(--warning-color);
	color: #744210;
}

.alert-success {
	background: #d4edda;
	color: #155724;
	border-color: var(--success-color);
}

.alert-error {
	background: #f8d7da;
	color: #721c24;
	border-color: var(--danger-color);
}

/* Mobile responsiveness */
@media (max-width: 480px) {
	.wizard-steps {
		flex-direction: column;
		align-items: flex-start;
		padding: 0;
	}

	.wizard-actions {
		flex-direction: column;
	}

	.btn-large {
		width: 100%;
		text-align: center;
	}

	.weight-display {
		font-size: 1.5rem;
		min-height: 3rem;
	}

	.product-grid {
		grid-template-columns: 1fr;
		max-height: 300px;
	}
}`, "",{"version":3,"sources":["webpack://./src/styles/components.css"],"names":[],"mappings":"AAAA,8BAA8B;;AAE9B,kBAAkB;AAClB;CACC,uBAAuB;CACvB,YAAY;CACZ,+BAA+B;CAC/B,eAAe;CACf,gBAAgB;CAChB,eAAe;CACf,kCAAkC;CAClC,oBAAoB;CACpB,mBAAmB;CACnB,uBAAuB;CACvB,sBAAsB;CACtB,qBAAqB;CACrB,gBAAgB,EAAE,wCAAwC;AAC3D;;AAEA;CACC,aAAa;CACb,+BAA+B;AAChC;;AAEA;CACC,YAAY;CACZ,mBAAmB;CACnB,0BAA0B;AAC3B;;AAEA;CACC,mCAAmC;CACnC,YAAY;AACb;;AAEA;CACC,2BAA2B;CAC3B,+CAA+C;AAChD;;AAEA;CACC,mBAAmB;CACnB,4BAA4B;AAC7B;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,gCAAgC;CAChC,YAAY;AACb;;AAEA;CACC,gCAAgC;CAChC,2BAA2B;AAC5B;;AAEA;CACC,gCAAgC;CAChC,4BAA4B;AAC7B;;AAEA;CACC,mBAAmB;CACnB,2BAA2B;AAC5B;;AAEA;CACC,+BAA+B;CAC/B,YAAY;AACb;;AAEA;CACC,mBAAmB;CACnB,2BAA2B;AAC5B;;AAEA;CACC,mBAAmB;CACnB,YAAY;AACb;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,6CAA6C;CAC7C,kBAAkB;CAClB,+BAA+B;AAChC;;AAEA;CACC,4CAA4C;CAC5C,mBAAmB;AACpB;;AAEA;CACC,uBAAuB;CACvB,YAAY;AACb;;AAEA,iBAAiB;AACjB;CACC,aAAa;CACb,8BAA8B;CAC9B,sBAAsB;CACtB,6BAA6B;AAC9B;;AAEA,oCAAoC;AACpC;;;;;;;;;GASG;;AAEH;CACC,aAAa;CACb,2DAA2D;CAC3D,sBAAsB;CACtB,2BAA2B;AAC5B;;AAEA;CACC,aAAa;CACb,8BAA8B;CAC9B,mBAAmB;CACnB,SAAS;CACT,gCAAgC;AACjC;;AAEA;CACC,aAAa;CACb,sBAAsB;AACvB;;AAEA;CACC;EACC,0BAA0B;EAC1B,sBAAsB;EACtB,2BAA2B;CAC5B;;CAEA;EACC,0BAA0B;EAC1B,sBAAsB;EACtB,2BAA2B;CAC5B;;CAEA,0CAA0C;CAC1C;;;;;;;;;IASG;AACJ;;AAEA,gBAAgB;AAChB;CACC,0BAA0B;CAC1B,+BAA+B;CAC/B,0BAA0B;CAC1B,0CAA0C;CAC1C,4BAA4B;CAC5B,kCAAkC;AACnC;;AAEA;;;GAGG;;AAEH,gBAAgB;AAChB;CACC,gCAAgC;AACjC;;AAEA;CACC,cAAc;CACd,gBAAgB;CAChB,gCAAgC;CAChC,4BAA4B;AAC7B;;AAEA;;CAEC,WAAW;CACX,gBAAgB;CAChB,qCAAqC;CACrC,+BAA+B;CAC/B,eAAe;CACf,kCAAkC;CAClC,iBAAiB;CACjB,gBAAgB,EAAE,kBAAkB;AACrC;;AAEA;;CAEC,aAAa;CACb,iCAAiC;CACjC,+BAA+B;AAChC;;AAEA;CACC,iCAAiC;AAClC;;AAEA,uBAAuB;AACvB;CACC,gBAAgB;CAChB,+BAA+B;CAC/B,kBAAkB;CAClB,aAAa;CACb,mBAAmB;CACnB,uBAAuB;CACvB,YAAY;CACZ,kBAAkB;CAClB,gCAAgC;CAChC,kBAAkB;CAClB,gBAAgB;AACjB;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,iBAAiB;AAClB;;AAEA;CACC,kBAAkB;CAClB,YAAY;CACZ,UAAU;CACV,6BAA6B;CAC7B,YAAY;CACZ,0BAA0B;CAC1B,qCAAqC;CACrC,mBAAmB;CACnB,kBAAkB;AACnB;;AAEA,0BAA0B;AAC1B;CACC,mBAAmB;CACnB,cAAc;CACd,qCAAqC;CACrC,eAAe;CACf,iBAAiB;CACjB,0BAA0B;CAC1B,+BAA+B;CAC/B,kBAAkB;CAClB,2BAA2B;CAC3B,gBAAgB;CAChB,aAAa;CACb,mBAAmB;CACnB,uBAAuB;CACvB,4BAA4B;AAC7B;;AAEA;CACC,KAAK,4CAA4C,EAAE;CACnD,MAAM,6CAA6C,EAAE;CACrD,OAAO,0CAA0C,EAAE;AACpD;;AAEA,4BAA4B;AAC5B;CACC,aAAa;CACb,mBAAmB;CACnB,sBAAsB;CACtB,kCAAkC;CAClC,iCAAiC;CACjC,mBAAmB;CACnB,gBAAgB;CAChB,kCAAkC;AACnC;;AAEA;CACC,mBAAmB;CACnB,cAAc;AACf;;AAEA;CACC,mBAAmB;CACnB,cAAc;AACf;;AAEA;CACC,UAAU;CACV,WAAW;CACX,kBAAkB;CAClB,oCAAoC;AACrC;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,UAAU,UAAU,EAAE;CACtB,YAAY,YAAY,EAAE;AAC3B;;AAEA,kBAAkB;AAClB;CACC,aAAa;CACb,6BAA6B;CAC7B,gCAAgC;CAChC,4BAA4B;CAC5B,gBAAgB;CAChB,sBAAsB;CACtB,iBAAiB;CACjB,4CAA4C;CAC5C,yCAAyC;CACzC,4BAA4B;AAC7B;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,sBAAsB;CACtB,wBAAwB;CACxB,gBAAgB;CAChB,mBAAmB;CACnB,kCAAkC;AACnC;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;CAC3B,eAAe;AAChB;;AAEA;CACC,yBAAyB;CACzB,sBAAsB;CACtB,yBAAyB;AAC1B;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,kBAAkB;CAClB,+BAA+B;CAC/B,4BAA4B;CAC5B,aAAa;CACb,mBAAmB;CACnB,uBAAuB;CACvB,iBAAiB;CACjB,mBAAmB;CACnB,kCAAkC;AACnC;;AAEA;CACC,gCAAgC;CAChC,YAAY;CACZ,qBAAqB;AACtB;;AAEA;CACC,gCAAgC;CAChC,YAAY;AACb;;AAEA;CACC,aAAa;CACb,8BAA8B;CAC9B,6BAA6B;CAC7B,8BAA8B;CAC9B,yCAAyC;CACzC,sBAAsB;AACvB;;AAEA,gCAAgC;AAChC;CACC,aAAa;CACb,4DAA4D;CAC5D,sBAAsB;CACtB,uBAAuB;CACvB,+BAA+B;CAC/B,gBAAgB;CAChB,0BAA0B;CAC1B,qCAAqC;CACrC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,0BAA0B;CAC1B,qCAAqC;CACrC,+BAA+B;CAC/B,eAAe;CACf,kCAAkC;CAClC,kBAAkB;CAClB,iBAAiB;AAClB;;AAEA;CACC,kCAAkC;CAClC,mBAAmB;CACnB,2BAA2B;AAC5B;;AAEA;CACC,kCAAkC;CAClC,mBAAmB;AACpB;;AAEA,uBAAuB;AACvB;CACC,gCAAgC;AACjC;;AAEA;CACC,gCAAgC;AACjC;;AAEA;CACC,gCAAgC;CAChC,4BAA4B;AAC7B;;AAEA,0BAA0B;AAC1B;CACC,aAAa;CACb,sBAAsB;CACtB,mBAAmB;CACnB,uBAAuB;CACvB,kBAAkB;CAClB,sBAAsB;CACtB,gBAAgB;AACjB;;AAEA;CACC,eAAe;CACf,2BAA2B;CAC3B,6BAA6B;AAC9B;;AAEA;CACC,0BAA0B,wBAAwB,EAAE;CACpD,WAAW,4BAA4B,EAAE;CACzC,MAAM,2BAA2B,EAAE;CACnC,MAAM,2BAA2B,EAAE;AACpC;;AAEA,kBAAkB;AAClB;CACC,+BAA+B;CAC/B,+BAA+B;CAC/B,gBAAgB;CAChB,2BAA2B;AAC5B;;AAEA;CACC,aAAa;CACb,8BAA8B;CAC9B,0BAA0B;CAC1B,4CAA4C;CAC5C,mBAAmB;AACpB;;AAEA;CACC,mBAAmB;CACnB,iBAAiB;CACjB,mBAAmB;AACpB;;AAEA,0BAA0B;AAC1B;CACC,aAAa;CACb,mBAAmB;CACnB,sBAAsB;CACtB,gCAAgC;CAChC,mBAAmB;CACnB,wBAAwB;AACzB;;AAEA;CACC,2BAA2B;CAC3B,qBAAqB;CACrB,eAAe;CACf,kCAAkC;AACnC;;AAEA;CACC,0BAA0B;CAC1B,2BAA2B;AAC5B;;AAEA,oBAAoB;AACpB;CACC,WAAW;CACX,YAAY;CACZ,qCAAqC;CACrC,0CAA0C;CAC1C,kBAAkB;CAClB,kCAAkC;CAClC,cAAc;AACf;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,SAAS;CACT,uBAAuB;EACtB;;EAEA;CACD,gBAAgB;CAChB,WAAW;EACV;;EAEA;CACD,YAAY;CACZ,iBAAiB;CACjB,sBAAsB;CACtB,kBAAkB;CAClB,eAAe;CACf,WAAW;CACX,sBAAsB;CACtB,aAAa;CACb,8CAA8C;EAC7C;;EAEA;CACD,qBAAqB;CACrB,6CAA6C;EAC5C;;;AAGF;CACC,KAAK,uBAAuB,EAAE;CAC9B,OAAO,yBAAyB,EAAE;AACnC;;AAEA,kCAAkC;AAClC;CACC,0BAA0B;CAC1B,+BAA+B;CAC/B,2BAA2B;CAC3B,iBAAiB;AAClB;;AAEA;CACC,mBAAmB;CACnB,kCAAkC;CAClC,cAAc;AACf;;AAEA;CACC,mBAAmB;CACnB,cAAc;CACd,kCAAkC;AACnC;;AAEA;CACC,mBAAmB;CACnB,cAAc;CACd,iCAAiC;AAClC;;AAEA,0BAA0B;AAC1B;CACC;EACC,sBAAsB;EACtB,uBAAuB;EACvB,UAAU;CACX;;CAEA;EACC,sBAAsB;CACvB;;CAEA;EACC,WAAW;EACX,kBAAkB;CACnB;;CAEA;EACC,iBAAiB;EACjB,gBAAgB;CACjB;;CAEA;EACC,0BAA0B;EAC1B,iBAAiB;CAClB;AACD","sourcesContent":["/* Component-specific styles */\n\n/* Button styles */\n.btn {\n\tpadding: 0.75rem 1.5rem;\n\tborder: none;\n\tborder-radius: var(--radius-md);\n\tfont-size: 1rem;\n\tfont-weight: 500;\n\tcursor: pointer;\n\ttransition: var(--transition-fast);\n\tdisplay: inline-flex;\n\talign-items: center;\n\tjustify-content: center;\n\tgap: var(--spacing-sm);\n\ttext-decoration: none;\n\tmin-height: 44px; /* Accessibility: minimum touch target */\n}\n\n.btn:focus {\n\toutline: none;\n\tbox-shadow: var(--shadow-focus);\n}\n\n.btn:disabled {\n\topacity: 0.5;\n\tcursor: not-allowed;\n\ttransform: none !important;\n}\n\n.btn-primary {\n\tbackground: var(--primary-gradient);\n\tcolor: white;\n}\n\n.btn-primary:hover:not(:disabled) {\n\ttransform: translateY(-2px);\n\tbox-shadow: 0 4px 20px rgba(102, 126, 234, 0.4);\n}\n\n.btn-secondary {\n\tbackground: #e2e8f0;\n\tcolor: var(--text-secondary);\n}\n\n.btn-secondary:hover:not(:disabled) {\n\tbackground: #cbd5e0;\n}\n\n.btn-success {\n\tbackground: var(--success-color);\n\tcolor: white;\n}\n\n.btn-success:hover:not(:disabled) {\n\tbackground: var(--success-hover);\n\ttransform: translateY(-1px);\n}\n\n.btn-warning {\n\tbackground: var(--warning-color);\n\tcolor: var(--text-secondary);\n}\n\n.btn-warning:hover:not(:disabled) {\n\tbackground: #ecc94b;\n\ttransform: translateY(-1px);\n}\n\n.btn-danger {\n\tbackground: var(--danger-color);\n\tcolor: white;\n}\n\n.btn-danger:hover:not(:disabled) {\n\tbackground: #c53030;\n\ttransform: translateY(-1px);\n}\n\n.btn-info {\n\tbackground: #17a2b8;\n\tcolor: white;\n}\n\n.btn-info:hover:not(:disabled) {\n\tbackground: #138496;\n}\n\n.btn-large {\n\tpadding: var(--spacing-lg) var(--spacing-xxl);\n\tfont-size: 1.25rem;\n\tborder-radius: var(--radius-lg);\n}\n\n.btn-small {\n\tpadding: var(--spacing-sm) var(--spacing-md);\n\tfont-size: 0.875rem;\n}\n\n.btn-transparent {\n\tbackground: transparent;\n\tborder: none;\n}\n\n/* Layout grids */\n.grid-2 {\n\tdisplay: grid;\n\tgrid-template-columns: 1fr 1fr;\n\tgap: var(--spacing-xl);\n\tmargin-top: var(--spacing-xl);\n}\n\n/* Home screen action buttons grid */\n/* .home .action-buttons {\n\tdisplay: grid;\n\tgrid-template-areas: \n\t\t\"btn-reg btn-tkt btn-tickets\"\n\t\t\"status activity activity\";\n\tgrid-template-columns: 1fr 1fr 1fr;\n\tgrid-template-rows: auto auto;\n\tgap: var(--spacing-lg);\n\tmargin: var(--spacing-lg) 0;\n} */\n\n.grid-3 {\n\tdisplay: grid;\n\tgrid-template-columns: repeat(auto-fit, minmax(280px, 1fr));\n\tgap: var(--spacing-lg);\n\tmargin: var(--spacing-xl) 0;\n}\n\n.user-info {\n\tdisplay: flex;\n\tjustify-content: space-between;\n\talign-items: center;\n\tgap: 20px;\n\tmargin-bottom: var(--spacing-md);\n}\n\n.user-info-text {\n\tdisplay: flex;\n\tflex-direction: column;\n}\n\n@media (max-width: 768px) {\n\t.grid-2 {\n\t\tgrid-template-columns: 1fr;\n\t\tgap: var(--spacing-md);\n\t\tmargin: var(--spacing-md) 0;\n\t}\n\n\t.grid-3 {\n\t\tgrid-template-columns: 1fr;\n\t\tgap: var(--spacing-md);\n\t\tmargin: var(--spacing-md) 0;\n\t}\n\n\t/* Responsive home screen action buttons */\n\t/* .home .action-buttons {\n\t\tgrid-template-areas: \n\t\t\t\"btn-reg\"\n\t\t\t\"btn-tkt\"\n\t\t\t\"btn-tickets\"\n\t\t\t\"status\"\n\t\t\t\"activity\";\n\t\tgrid-template-columns: 1fr;\n\t\tgrid-template-rows: auto auto auto auto auto;\n\t} */\n}\n\n/* Card styles */\n.card {\n\tbackground: var(--bg-card);\n\tborder-radius: var(--radius-lg);\n\tpadding: var(--spacing-lg);\n\tborder: 1px solid rgba(255, 255, 255, 0.3);\n\tbox-shadow: var(--shadow-md);\n\ttransition: var(--transition-fast);\n}\n\n/* .card:hover {\n\ttransform: translateY(-2px);\n\tbox-shadow: var(--shadow-lg);\n} */\n\n/* Form styles */\n.form-group {\n\tmargin-bottom: var(--spacing-lg);\n}\n\n.form-label {\n\tdisplay: block;\n\tfont-weight: 600;\n\tmargin-bottom: var(--spacing-sm);\n\tcolor: var(--text-secondary);\n}\n\n.form-input,\n.form-select {\n\twidth: 100%;\n\tpadding: 0.75rem;\n\tborder: 2px solid var(--border-light);\n\tborder-radius: var(--radius-md);\n\tfont-size: 1rem;\n\ttransition: var(--transition-fast);\n\tbackground: white;\n\tmin-height: 44px; /* Accessibility */\n}\n\n.form-input:focus,\n.form-select:focus {\n\toutline: none;\n\tborder-color: var(--border-focus);\n\tbox-shadow: var(--shadow-focus);\n}\n\n.form-input:invalid {\n\tborder-color: var(--danger-color);\n}\n\n/* Camera feed styles */\n.camera-feed {\n\tbackground: #000;\n\tborder-radius: var(--radius-md);\n\taspect-ratio: 16/9;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tcolor: white;\n\tfont-size: 1.25rem;\n\tmargin-bottom: var(--spacing-md);\n\tposition: relative;\n\toverflow: hidden;\n}\n\n.camera-feed img {\n\twidth: 100%;\n\theight: 100%;\n\tobject-fit: cover;\n}\n\n.camera-overlay {\n\tposition: absolute;\n\tbottom: 10px;\n\tleft: 10px;\n\tbackground: var(--bg-overlay);\n\tcolor: white;\n\tpadding: var(--spacing-sm);\n\tborder-radius: 0 var(--radius-lg) 0 0;\n\tfont-size: 0.875rem;\n\twidth: fit-content;\n}\n\n/* Weight display styles */\n.weight-display {\n\tbackground: #2d3748;\n\tcolor: #68d391;\n\tfont-family: 'Courier New', monospace;\n\tfont-size: 2rem;\n\tfont-weight: bold;\n\tpadding: var(--spacing-md);\n\tborder-radius: var(--radius-md);\n\ttext-align: center;\n\tmargin: var(--spacing-md) 0;\n\tmin-height: 4rem;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tanimation: pulse 2s infinite;\n}\n\n@keyframes pulse {\n\t0% { box-shadow: 0 0 0 0 rgba(104, 211, 145, 0.7); }\n\t70% { box-shadow: 0 0 0 10px rgba(104, 211, 145, 0); }\n\t100% { box-shadow: 0 0 0 0 rgba(104, 211, 145, 0); }\n}\n\n/* Status indicator styles */\n.status-indicator {\n\tdisplay: flex;\n\talign-items: center;\n\tgap: var(--spacing-sm);\n\tpadding: var(--spacing-xs) 0.75rem;\n\tborder-radius: var(--radius-pill);\n\tfont-size: 0.875rem;\n\tfont-weight: 500;\n\ttransition: var(--transition-fast);\n}\n\n.status-connected {\n\tbackground: #d4edda;\n\tcolor: #155724;\n}\n\n.status-disconnected {\n\tbackground: #f8d7da;\n\tcolor: #721c24;\n}\n\n.status-dot {\n\twidth: 8px;\n\theight: 8px;\n\tborder-radius: 50%;\n\t/* animation: blink 1.5s infinite; */\n}\n\n.connected .status-dot {\n\tbackground: #28a745;\n}\n\n.disconnected .status-dot {\n\tbackground: var(--danger-color);\n}\n\n@keyframes blink {\n\t0%, 50% { opacity: 1; }\n\t51%, 100% { opacity: 0.3; }\n}\n\n/* Wizard styles */\n.wizard-steps {\n\tdisplay: flex;\n\tjustify-content: space-evenly;\n\tmargin-bottom: var(--spacing-xl);\n\tpadding: 0 var(--spacing-xl);\n\toverflow-x: auto;\n\tgap: var(--spacing-md);\n\toverflow: visible;\n\tborder-bottom: 1px solid var(--border-light);\n\tborder-top: 1px solid var(--border-light);\n\tpadding: var(--spacing-md) 0;\n}\n\n.wizard-step {\n\tdisplay: flex;\n\talign-items: center;\n\tgap: var(--spacing-sm);\n\tcolor: var(--text-light);\n\tfont-weight: 500;\n\twhite-space: nowrap;\n\ttransition: var(--transition-fast);\n}\n\n.wizard-step.active {\n\tcolor: var(--primary-color);\n}\n\n.wizard-step.completed {\n\tcolor: var(--success-color);\n\tcursor: pointer;\n}\n\n.wizard-step.completed:hover {\n\tbackground-color: #f0f0f0;\n\ttransform: scale(1.02);\n\ttransition: all 0.2s ease;\n}\n\n.step-number {\n\twidth: 32px;\n\theight: 32px;\n\tborder-radius: 50%;\n\tbackground: var(--border-light);\n\tcolor: var(--text-secondary);\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tfont-weight: bold;\n\tfont-size: 0.875rem;\n\ttransition: var(--transition-fast);\n}\n\n.wizard-step.active .step-number {\n\tbackground: var(--primary-color);\n\tcolor: white;\n\ttransform: scale(1.1);\n}\n\n.wizard-step.completed .step-number {\n\tbackground: var(--success-color);\n\tcolor: white;\n}\n\n.wizard-actions {\n\tdisplay: flex;\n\tjustify-content: space-between;\n\tmargin-top: var(--spacing-xl);\n\tpadding-top: var(--spacing-xl);\n\tborder-top: 1px solid var(--border-light);\n\tgap: var(--spacing-md);\n}\n\n/* Product and selection grids */\n.product-grid {\n\tdisplay: grid;\n\tgrid-template-columns: repeat(auto-fill, minmax(200px, 1fr));\n\tgap: var(--spacing-md);\n\t/* max-height: 400px; */\n\tmax-height: calc(100vh - 670px);\n\toverflow-y: auto;\n\tpadding: var(--spacing-md);\n\tborder: 1px solid var(--border-light);\n\tborder-radius: var(--radius-md);\n}\n\n.product-grid.projects {\n\tmax-height: calc(100vh - 520px);\n}\n\n.product-item {\n\tpadding: var(--spacing-md);\n\tborder: 2px solid var(--border-light);\n\tborder-radius: var(--radius-md);\n\tcursor: pointer;\n\ttransition: var(--transition-fast);\n\ttext-align: center;\n\tbackground: white;\n}\n\n.product-item:hover {\n\tborder-color: var(--primary-color);\n\tbackground: #f7fafc;\n\ttransform: translateY(-2px);\n}\n\n.product-item.selected {\n\tborder-color: var(--primary-color);\n\tbackground: #ebf4ff;\n}\n\n/* Search and filters */\n.search-box {\n\tmargin-bottom: var(--spacing-md);\n}\n\n.recently-used {\n\tmargin-bottom: var(--spacing-xl);\n}\n\n.recently-used h3 {\n\tmargin-bottom: var(--spacing-md);\n\tcolor: var(--text-secondary);\n}\n\n/* Authentication screen */\n.auth-screen {\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: center;\n\tjustify-content: center;\n\ttext-align: center;\n\tgap: var(--spacing-xl);\n\tmin-height: 60vh;\n}\n\n.auth-icon {\n\tfont-size: 4rem;\n\tcolor: var(--primary-color);\n\tanimation: bounce 2s infinite;\n}\n\n@keyframes bounce {\n\t0%, 20%, 53%, 80%, 100% { transform: translateY(0); }\n\t40%, 43% { transform: translateY(-10px); }\n\t70% { transform: translateY(-5px); }\n\t90% { transform: translateY(-2px); }\n}\n\n/* Summary table */\n.summary-table {\n\tbackground: var(--bg-secondary);\n\tborder-radius: var(--radius-md);\n\toverflow: hidden;\n\tmargin: var(--spacing-md) 0;\n}\n\n.summary-row {\n\tdisplay: flex;\n\tjustify-content: space-between;\n\tpadding: var(--spacing-md);\n\tborder-bottom: 1px solid var(--border-light);\n\talign-items: center;\n}\n\n.summary-row:last-child {\n\tborder-bottom: none;\n\tfont-weight: bold;\n\tbackground: #f7fafc;\n}\n\n/* Navigation breadcrumb */\n.nav-breadcrumb {\n\tdisplay: flex;\n\talign-items: center;\n\tgap: var(--spacing-sm);\n\tmargin-bottom: var(--spacing-md);\n\tfont-size: 0.875rem;\n\tcolor: var(--text-muted);\n}\n\n.nav-breadcrumb a {\n\tcolor: var(--primary-color);\n\ttext-decoration: none;\n\tcursor: pointer;\n\ttransition: var(--transition-fast);\n}\n\n.nav-breadcrumb a:hover {\n\ttext-decoration: underline;\n\tcolor: var(--primary-hover);\n}\n\n/* Loading spinner */\n.loading-spinner {\n\twidth: 40px;\n\theight: 40px;\n\tborder: 4px solid var(--border-light);\n\tborder-top: 4px solid var(--primary-color);\n\tborder-radius: 50%;\n\tanimation: spin 1s linear infinite;\n\tmargin: 0 auto;\n}\n\n.date-selector {\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 10px;\n\tfont-family: sans-serif;\n  }\n  \n  .date-label {\n\tfont-weight: 500;\n\tcolor: #333;\n  }\n  \n  .date-input {\n\twidth: 160px;\n\tpadding: 6px 10px;\n\tborder: 1px solid #ccc;\n\tborder-radius: 6px;\n\tfont-size: 14px;\n\tcolor: #333;\n\tbackground-color: #fff;\n\toutline: none;\n\ttransition: border-color 0.2s, box-shadow 0.2s;\n  }\n  \n  .date-input:focus {\n\tborder-color: #4a90e2;\n\tbox-shadow: 0 0 0 2px rgba(74, 144, 226, 0.2);\n  }\n  \n\n@keyframes spin {\n\t0% { transform: rotate(0deg); }\n\t100% { transform: rotate(360deg); }\n}\n\n/* Alert and notification styles */\n.alert {\n\tpadding: var(--spacing-md);\n\tborder-radius: var(--radius-md);\n\tmargin: var(--spacing-md) 0;\n\tborder: 1px solid;\n}\n\n.alert-warning {\n\tbackground: #fef5e7;\n\tborder-color: var(--warning-color);\n\tcolor: #744210;\n}\n\n.alert-success {\n\tbackground: #d4edda;\n\tcolor: #155724;\n\tborder-color: var(--success-color);\n}\n\n.alert-error {\n\tbackground: #f8d7da;\n\tcolor: #721c24;\n\tborder-color: var(--danger-color);\n}\n\n/* Mobile responsiveness */\n@media (max-width: 480px) {\n\t.wizard-steps {\n\t\tflex-direction: column;\n\t\talign-items: flex-start;\n\t\tpadding: 0;\n\t}\n\n\t.wizard-actions {\n\t\tflex-direction: column;\n\t}\n\n\t.btn-large {\n\t\twidth: 100%;\n\t\ttext-align: center;\n\t}\n\n\t.weight-display {\n\t\tfont-size: 1.5rem;\n\t\tmin-height: 3rem;\n\t}\n\n\t.product-grid {\n\t\tgrid-template-columns: 1fr;\n\t\tmax-height: 300px;\n\t}\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
